import { render, staticRenderFns } from "./floatWindow.vue?vue&type=template&id=3b86a1a2&scoped=true&"
import script from "./floatWindow.vue?vue&type=script&lang=js&"
export * from "./floatWindow.vue?vue&type=script&lang=js&"
import style0 from "./floatWindow.vue?vue&type=style&index=0&id=3b86a1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86a1a2",
  null
  
)

export default component.exports